import { useState, useEffect } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import ModalNegociacao from '../ModalDetalhesWarmup/ModalDetalhesWarmup';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../Auth/AuthContext/AuthContext";
import useGroupMembers from "../../hooks/useGroupMembers";




const ControleProjetos = () => {
    const { userData } = useAuth();
    const USER_NAME = userData?.user?.displayName; // Obtém o nome do usuário logado
    const [dados, setDados] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showIniciarModal, setShowIniciarModal] = useState(false);
    const [showArquivarModal, setShowArquivarModal] = useState(false);
    const [responsavel, setResponsavel] = useState(null);
    const [currentProjeto, setCurrentProjeto] = useState(null);

    const [dadosWarmup, setDadosWarmup] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [negociacaoSelecionada, setNegociacaoSelecionada] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] = useState({ start: '', end: '' });
    const [relativeDate, setRelativeDate] = useState('');
    const [etapaFilter, setEtapaFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [gerenteFilter, setGerenteFilter] = useState('');
    const [centroResultadoFilter, setCentroResultadoFilter] = useState('');

    const [showVoltarModal, setShowVoltarModal] = useState(false);
    const [observacaoVoltar, setObservacaoVoltar] = useState("");
    const [currentItemVoltar, setCurrentItemVoltar] = useState(null);

    const { members: socios } = useGroupMembers('718b8873-3ca9-4bd1-bd3d-6b657fe2cf80'); // Para os sócios



    const API_URL = process.env.REACT_APP_API_URL || 'https://sic-conti-backend.vercel.app';

    const isGerente = (item) => item?.capa_projeto?.gerente_projeto?.nome === USER_NAME;
    const isSocioResponsavel = socios.some((socio) => socio.displayName === USER_NAME);

    const limparFiltros = () => {
        setSearchTerm('');
        setDateRange({ start: '', end: '' });
        setRelativeDate('');
        setEtapaFilter('');
        setStatusFilter('');
        setGerenteFilter('');
        setCentroResultadoFilter('');
        setFilteredData(dadosWarmup);
    };


    async function listarWarmup() {
        try {
            const response = await fetch(`${API_URL}/api/listar_warmup`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
            }

            const data = await response.json();
            setDadosWarmup(data.data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        listarWarmup();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.menu-dropdown')) {
                setActiveMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const filtered = dadosWarmup.filter(item => {
            const gerenteNome = item?.capa_projeto?.gerente_projeto?.nome?.toLowerCase() ?? '';
            const centroNome = item?.capa_projeto?.centro_resultado?.NOME?.toLowerCase() ?? '';
            const codigoProjeto = item?.capa_projeto?.codigo?.toLowerCase() ?? '';
            const inicioWarmup = new Date(item?.inicio_warmup);

            const startDate = dateRange.start ? new Date(dateRange.start) : null;
            const endDate = dateRange.end ? new Date(dateRange.end) : null;

            const matchesFilters = (
                (etapaFilter === '' || item.etapa === etapaFilter) &&
                (statusFilter === '' || item.status === statusFilter) &&
                (searchTerm === '' || codigoProjeto.includes(searchTerm.toLowerCase())) &&
                (gerenteFilter === '' || gerenteNome.includes(gerenteFilter.toLowerCase())) &&
                (centroResultadoFilter === '' || centroNome.includes(centroResultadoFilter.toLowerCase())) &&
                (!startDate || inicioWarmup >= startDate) &&
                (!endDate || inicioWarmup <= endDate)
            );

            if (isSocioResponsavel) {
                return matchesFilters;
            } else {
                return matchesFilters && isGerente(item);
            }
        });
        setFilteredData(filtered);
    }, [etapaFilter, statusFilter, searchTerm, gerenteFilter, centroResultadoFilter, dateRange, dadosWarmup, isSocioResponsavel]);

    const abrirModal = (negociacao) => {
        setNegociacaoSelecionada(negociacao);
        setActiveMenu(null); // Fecha o menu ao abrir o modal
    };

    const fecharModal = () => {
        setNegociacaoSelecionada(null);
    };

    const toggleMenu = (id) => {
        setActiveMenu(activeMenu === id ? null : id);
    };

    const handleAvancarEtapa = (item) => {
        setCurrentItem(item);
        setShowConfirmModal(true);
        setActiveMenu(null); // Fecha o menu ao avançar etapa
    };

    const enviarEmailNotificacaoEncerramento = async (item) => {
        const warmupUrl = `${window.location.origin}/financeiro/projetos`;

        const emailBody = `
            <p>Olá,</p>
            <p>Foi solicitado o encerramento para o projeto <strong>${item.capa_projeto.codigo}</strong>.</p>
            <p><a href="${warmupUrl}" target="_blank">Clique aqui para ver o controle de projetos</a></p>
            <p>Atenciosamente,<br>Equipe ConTI Consultoria</p>
        `;

        try {
            const emailResponse = await fetch(`${API_URL}/api/enviar-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    sender_email: "warmup@conticonsultoria.com.br",
                    recipient_email: "junia.mendes@conticonsultoria.com.br",
                    subject: `Solicitação de Encerramento do Projeto ${item.capa_projeto.codigo}`,
                    body_content: emailBody,
                }),
            });

            if (!emailResponse.ok) {
                const errorText = await emailResponse.text();
                throw new Error(`Erro ao enviar email: ${emailResponse.status} - ${errorText}`);
            }
            console.log("Email enviado com sucesso!");
        } catch (err) {
            console.error("Erro ao enviar email:", err.message);
        }
    };

    const confirmarAvancarEtapa = async () => {
        try {
            const response = await fetch(`${API_URL}/api/warmup/alterar_etapa/${currentItem._id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    etapa: 'Encerramento Financeiro',
                    status: 'Aguardando'
                }),
            });

            if (!response.ok) {
                throw new Error(`Erro ao atualizar etapa: ${response.statusText}`);
            }

            listarWarmup();
            alert('Etapa atualizada com sucesso!');
            await enviarEmailNotificacaoEncerramento(currentItem);
        } catch (error) {
            alert(`Erro ao atualizar etapa: ${error.message}`);
        } finally {
            setShowConfirmModal(false);
            setCurrentItem(null);
        }
    };

    const handleVoltarEtapa = (item) => {
        setCurrentItemVoltar(item);
        setShowVoltarModal(true);
        setActiveMenu(null); // Fecha o menu ao abrir o modal
    };

    const confirmarVoltarEtapa = async () => {
        try {
            const usuario = userData?.user?.displayName || "Usuário Anônimo"; // Obtém o nome do usuário

            const response = await fetch(`${API_URL}/api/warmup/alterar_etapa/${currentItemVoltar._id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    etapa: 'Warmup Comercial',
                    status: "Revisar",
                    data: new Date().toLocaleString("pt-BR"),
                    observacao: observacaoVoltar,
                    usuario: usuario, // Envia o nome do usuário logado
                }),
            });

            if (!response.ok) {
                throw new Error(`Erro ao atualizar etapa: ${response.statusText}`);
            }

            listarWarmup();
            alert('Etapa atualizada com sucesso!');
        } catch (error) {
            alert(`Erro ao atualizar etapa: ${error.message}`);
        } finally {
            setShowVoltarModal(false);
            setCurrentItemVoltar(null);
            setObservacaoVoltar("");
        }
    };

    const redirecionarFormulario = (id) => {
        navigate(`/forms-warmup-projetos/${id}`);
        setActiveMenu(null); // Fecha o menu ao redirecionar
    };

    return (
        <div className="flex flex-col p-4 min-h-screen w-full px-10">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold text-gray-800">Controle de Projetos</h1>
                <div className="flex items-center space-x-2">
                    <label className="text-gray-700">Início Warmup:</label>
                    <input
                        type="date"
                        value={dateRange.start}
                        onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
                        className="border border-gray-300 rounded-md p-2"
                    />
                    <span className="text-gray-700">até</span>
                    <input
                        type="date"
                        value={dateRange.end}
                        onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
                        className="border border-gray-300 rounded-md p-2"
                    />
                </div>
            </div>
            <div className="flex space-x-4 mb-4">
                <input
                    type="text"
                    placeholder="Buscar Projeto..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 flex-grow"
                />
                {isSocioResponsavel && (
                    <input
                        type="text"
                        placeholder="Gerente do Projeto"
                        value={gerenteFilter}
                        onChange={(e) => setGerenteFilter(e.target.value)}
                        className="border border-gray-300 rounded-md p-2 w-64"
                    />
                )}
                <input
                    type="text"
                    placeholder="Centro de Resultado"
                    value={centroResultadoFilter}
                    onChange={(e) => setCentroResultadoFilter(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-64"
                />
                <select
                    value={etapaFilter}
                    onChange={(e) => setEtapaFilter(e.target.value)}
                    className="border border-gray-300 rounded-md p-2"
                >
                    <option value="">Todas as Etapas</option>
                    <option value="Warmup Comercial">Warmup Comercial</option>
                    <option value="Warmup Projetos">Warmup Projetos</option>
                    <option value="Warmup Financeiro">Warmup Financeiro</option>
                    <option value="Projeto Liberado">Projeto Liberado</option>
                    <option value="Encerramento Financeiro">Encerramento Financeiro</option>
                    <option value="Projeto Encerrado">Projeto Encerrado</option>
                </select>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="border border-gray-300 rounded-md p-2"
                >
                    <option value="">Todos os Status</option>
                    <option value="Revisar">Revisar</option>
                    <option value="Preenchendo">Preenchendo</option>
                    <option value="Liberado">Liberado</option>
                    <option value="Encerrado">Encerrado</option>
                </select>
                <button
                    onClick={limparFiltros}
                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                >
                    Limpar Filtros
                </button>
            </div>
            {loading && <p className="text-sm font-medium text-gray-600">Carregando...</p>}
            {error && <p className="text-sm font-medium text-red-500">Erro: {error}</p>}
            {!loading && !error && filteredData.length === 0 && (
                <p className="text-sm font-medium text-gray-600">Nenhum projeto retornado.</p>
            )}
            {!loading && !error && filteredData.length > 0 && (
                <div className="max-w bg-white rounded-lg shadow-md">
                    <table className="table-auto w-full text-sm text-left border-collapse">
                        <thead className="bg-gray-200">
                            <tr>
                                <th className="px-2 py-1 font-semibold text-gray-600">Gerente do Projeto</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Código do Projeto</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Centro de Resultados</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Valor</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Status</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Etapa</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Início Warmup</th>
                                <th className="px-2 py-1 text-center font-semibold text-gray-600">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item) => (
                                <tr key={item._id} className="hover:bg-gray-50">
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.gerente_projeto?.nome || "N/A"}</td>
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.codigo || ""}</td>
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.centro_resultado?.NOME || "N/A"}</td>
                                    <td className="px-2 py-1 text-gray-700">
                                        {new Intl.NumberFormat('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        }).format(item?.formacao_preco?.valor || "")}
                                    </td>
                                    <td className="px-2 py-1">
                                        <span
                                            className={`font-semibold ${(() => {
                                                switch (item.status) {
                                                    case "Revisar":
                                                        return "text-amber-500";
                                                    case "Preenchendo":
                                                        return "text-blue-400";
                                                    case "Liberado":
                                                        return "text-green-400";
                                                    case "Encerrado":
                                                        return "text-red-400";
                                                    default:
                                                        return "text-gray-700";
                                                }
                                            })()}`}
                                        >
                                            {item.status || "N/A"}
                                        </span>
                                    </td>
                                    <td className="px-2 py-1 text-gray-700">{item.etapa}</td>
                                    <td className="px-2 py-1 text-gray-700">{new Date(item.inicio_warmup).toLocaleDateString("pt-BR")}</td>
                                    <td className="px-2 py-1 relative text-center">
                                        <button
                                            onClick={() => toggleMenu(item._id)}
                                            className="p-2 rounded-full text-gray-600 hover:bg-gray-100 transition"
                                        >
                                            <FaEllipsisH />
                                        </button>
                                        {activeMenu === item._id && (
                                            <div className="menu-dropdown absolute z-10 right-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded transition-transform duration-150 transform text-center">
                                                <button
                                                    onClick={() => abrirModal(item)}
                                                    className="text-gray-700 px-4 py-2 hover:bg-gray-100 w-full text-center"
                                                >
                                                    Ver Detalhes
                                                </button>
                                                {item.etapa === 'Projeto Liberado' && (
                                                    <button
                                                        onClick={() => handleAvancarEtapa(item)}
                                                        className="text-sky-700 px-4 py-2 hover:bg-sky-100 w-full text-center"
                                                    >
                                                        Solicitar Encerramento
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <ModalNegociacao negociacao={negociacaoSelecionada} onClose={fecharModal} />

            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
                    <div className="bg-white p-6 rounded shadow-lg">
                        <h2 className="text-lg font-semibold mb-4">Confirmar Avançar Etapa</h2>
                        <p className="mb-6">Tem certeza de que deseja solicitar o encerramento do projeto ?</p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmarAvancarEtapa}
                                className="px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600 transition"
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showVoltarModal && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
                    <div className="bg-white p-6 rounded shadow-lg max-w-lg w-full">
                        <h2 className="text-lg font-semibold mb-4">Voltar Etapa</h2>
                        <textarea
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none mb-4"
                            rows="4"
                            placeholder="Adicione uma observação antes de voltar a etapa..."
                            value={observacaoVoltar}
                            onChange={(e) => setObservacaoVoltar(e.target.value)}
                        ></textarea>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowVoltarModal(false)}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmarVoltarEtapa}
                                className="px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600 transition"
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ControleProjetos;
